<template>
  <simple-scrollable-modal class="image-upload-container">
    <template #title>
      <h4>{{ $t('uploadImage') }}</h4>
    </template>
    <template #content>
      <v-row class="image-container" justify="center">
        <v-col
          class="text-center"
          cols="auto"
          :class="['fileinput', { 'fileinput-loaded': hasImage }]"
        >
          <image-uploader
            :debug="1"
            :maxWidth="maxWidth"
            :maxHeight="maxHeight"
            :quality="0.8"
            :autoRotate="true"
            outputFormat="string"
            :preview="true"
            id="fileInput"
            :capture="false"
            accept="image/jpeg, image/jpg, image/gif, image/png"
            doNotResize="['gif', 'svg']"
            @input="setImage"
          >
            <label for="fileInput" slot="upload-label">
              <figure>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                >
                  <path
                    class="path1"
                    d="M9.5 19c0 3.59 2.91 6.5 6.5 6.5s6.5-2.91 6.5-6.5-2.91-6.5-6.5-6.5-6.5 2.91-6.5 6.5zM30 8h-7c-0.5-2-1-4-3-4h-8c-2 0-2.5 2-3 4h-7c-1.1 0-2 0.9-2 2v18c0 1.1 0.9 2 2 2h28c1.1 0 2-0.9 2-2v-18c0-1.1-0.9-2-2-2zM16 27.875c-4.902 0-8.875-3.973-8.875-8.875s3.973-8.875 8.875-8.875c4.902 0 8.875 3.973 8.875 8.875s-3.973 8.875-8.875 8.875zM30 14h-4v-2h4v2z"
                  ></path>
                </svg>
              </figure>
              <span class="upload-caption">
                {{
                  !hasImage
                    ? $t('uploadImage.select')
                    : $t('uploadImage.change')
                }}
              </span>
            </label>
          </image-uploader>
        </v-col>
      </v-row>
    </template>
    <template #action-bar>
      <div class="d-flex flex-row align-center justify-end">
        <v-btn text @click="cancel">{{ $t('cancel') }}</v-btn>
        <v-btn color="primary" @click="save" :disabled="!hasImage || loading">{{
          $t('upload')
        }}</v-btn>
      </div>
    </template>
  </simple-scrollable-modal>
</template>

<script lang="ts">
  import { Component, Prop, Vue } from 'vue-property-decorator';
  import { vueData } from '../../VueData';
  import { AlertType } from '../../interfaces/IAlert';
  import StaticService from '../../api/services/static.service';
  import SimpleScrollableModal from './base/SimpleScrollableModal.vue';
  import FileService from '@/api/services/file.service';
  import { dataURLtoFile } from '@/utils';

  @Component({
    components: { SimpleScrollableModal },
  })
  export default class ImageUploadModal extends Vue {
    @Prop({ default: 1920 }) maxWidth: number;
    @Prop({ default: 1080 }) maxHeight: number;
    hasImage = false;
    b64: string = null;
    staticService = new StaticService();
    loading = false;

    mounted() {}

    setImage(b64) {
      this.b64 = b64;
      this.hasImage = true;
    }

    async save() {
      this.loading = true;
      try {
        const file = dataURLtoFile(this.b64, 'image');
        let data = await FileService.upload(file);
        this.$parent.$emit('save', data);
        this.$emit('close');
      } catch (e) {
        console.error(e);
        vueData.addAlert(this.$tc('uploadImage.error'), AlertType.Error);
      } finally {
        this.loading = false;
      }
    }

    cancel() {
      this.$emit('close');
    }
  }
</script>
